import { DatePickerInput } from '@delmonicos/shared-design-system-react/src/components/date-picker-input/date-picker-input';
import { ModeEnum } from '@delmonicos/shared-design-system-react/src/components/date-picker/date-picker';
import { IconText } from '@delmonicos/shared-design-system-react/src/components/icon-text/icon-text';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { DateRangeFilterModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/core/src/models/inputs/date-range-filter.model';

interface DateRangeFilterControllerProps {
  iconName: string;
  text: string;
  fromLabel: string;
  toLabel: string;
  value?: DateRangeFilterModel;
  onChange: (value: DateRangeFilterModel | undefined) => void;
}

export const DateRangeFilterController = ({
  iconName,
  text,
  fromLabel,
  toLabel,
  value,
  onChange,
}: DateRangeFilterControllerProps): React.JSX.Element => {
  // HANDLERS //////////////////////////////////////////////////////////////////

  const handleChange = (partial: Partial<DateRangeFilterModel>) => {
    const next = { ...value, ...partial };

    onChange(next.min || next.max ? next : undefined);
  };

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Stack direction="column" gap={GapEnum.M}>
      <IconText iconName={iconName} text={text} />
      <Stack gap={GapEnum.S} direction="column">
        <DatePickerInput
          mode={ModeEnum.Single}
          selected={value?.min ? new Date(value.min) : undefined}
          label={fromLabel}
          onSelect={(min) => handleChange({ min })}
        />
        <DatePickerInput
          mode={ModeEnum.Single}
          selected={value?.max ? new Date(value.max) : undefined}
          label={toLabel}
          onSelect={(max) => handleChange({ max })}
        />
      </Stack>
    </Stack>
  );
};
